import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'om-svg-message',
  templateUrl: './svg-message.component.html',
})
export class SvgMessageComponent implements OnInit {
  @Input() stroke = 'black';

  constructor() {}

  ngOnInit() {}
}
